import { Padrao } from '../generic/padrao';

export class FiscalCstPis extends Padrao{

    override idTab = 181;

    descricao: string;
    valor: string;
}
